export default __webpack_public_path__ + "static/media/1.68888c3f.jpg";